import { render, staticRenderFns } from "./RCards.vue?vue&type=template&id=4ca6e262&"
import script from "./RCards.vue?vue&type=script&lang=js&"
export * from "./RCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports